<template>
  <DeleteButton :is-loading="isLoading" @click.native.stop="deletionConfirm">
    <slot />
  </DeleteButton>
</template>
<script>
import DeleteButton from './DeleteButton';

export default {
  name: 'DeleteWithConfirm',
  components: {
    DeleteButton,
  },
  props: {
    deleteFunction: {
      type: Function,
      required: true,
    },
    message: {
      type: String,
      default: function() {
        return this.$t('DELETE_ITEM_WARNING');
      },
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    delete() {
      this.isLoading = true;

      return this.deleteFunction().finally(() => {
        this.isLoading = false;
      });
    },
    deletionConfirm() {
      return this.$confirm(this.message, this.$t('WARNING'), {
        confirmButtonText: this.$t('DELETE_IT'),
        cancelButtonText: this.$t('CANCEL'),
        cancelButtonClass: 'el-button--text is-plain',
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
      })
        .then(() => {
          this.delete();
        })
        .catch(() => {
          // As there is nothing to do with this,
          // I only want to specify a function to handle
          // an unhandled promise rejection
        });
    },
  },
};
</script>
